import React, { useContext } from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import "./FacilityDetailsMain.scss";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader/Loader";
import FacilityDetails from "./FacilityDetails";
import SidebarFacility from "../SidebarFacility";
// import SidebarFacility from "../SidebarFacility";
// import ScheduleTable from "./ScheduleTable";

function FacilityDetailsMain() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  return (
    <div className="dashMain">
      <div className="sideBar">
        <SidebarFacility />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <SidebarFacility />
        </div>
      ) : (
        <div></div>
      )}
      {loading ? (
        <Loader />
      ) : (
        <div className="content">
          <div className="user" id="scrollable-container">
            <div className="svgMain" onClick={handleSvg}>
              {hideSvg ? (
                <div className="closeSvg"></div>
              ) : (
                <div className="hamburgerSvg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#0F0223"
                    stroke="#eee2e2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-menu"
                  >
                    <line x1="4" x2="20" y1="12" y2="12" />
                    <line x1="4" x2="20" y1="6" y2="6" />
                    <line x1="4" x2="20" y1="18" y2="18" />
                  </svg>
                </div>
              )}
            </div>

            <div className="userSec">
              {hideSvg ? (
                <div onClick={handleSvg}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#0F0223"
                    stroke="#eee2e2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-x-square"
                  >
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                    <path d="m15 9-6 6" />
                    <path d="m9 9 6 6" />
                  </svg>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="userContent">
            <FacilityDetails />
          </div>
        </div>
      )}
    </div>
  );
}

export default FacilityDetailsMain;
